import API from './Config';
import { AxiosPromise } from 'axios';


export function getClientsReachingLimits(): AxiosPromise<any> {
    return API.get(`/limits/clients`);
  }
export function getClientsReachingLimitsCount(): AxiosPromise<any> {
    return API.get(`/limits/count`);
  }